export default __webpack_public_path__ + "static/media/goal.bde735ea.jpg";